import { TDropItem } from 'src/types';

export const authorizationLevelOptions: TDropItem[] = [
  {
    value: '1',
    label: 'Level 1: I want to become a score recipient',
  },
  {
    value: '2',
    label: 'Level 2: I want to become a score recipient and administer assessments',
  },
];
